<template>
  <div class="input-verify" ref="inputVerify">
    <input
      type="number"
      v-for="(digit, index) in digits"
      :key="index"
      maxlength="1"
      :value="digit"
      @input="onChange($event, index)"
      @keyup="handleKeyup($event, index)"
      @keyup.delete="handleKeyupDelete($event)"
    />
  </div>
</template>
<script>
export default {
  data() {
    return {
      digits: Array.from(Array(this.length), () => null)
    };
  },
  props: {
    length: {
      type: Number,
      default: 4
    }
  },

  mounted() {
    this.$refs.inputVerify.firstElementChild.focus();
  },

  methods: {
    handleKeyup($event, index) {
      const inputValue = $event.key;
      const pattern = /^\d$/;
      const isNumber = pattern.test(inputValue);
      if (isNumber && $event.target.value !== inputValue) {
        $event.target.value = inputValue;
        this.onChange($event, index);
      }
      if (index + 1 < this.length && isNumber) {
        $event.target.nextElementSibling.focus();
      }
    },

    handleKeyupDelete($event) {
      if ($event.target.previousElementSibling) {
        $event.target.previousElementSibling.focus();
      }
    },

    onChange($event, index) {
      const value = $event.target.value;

      if (value) {
        const number = value.replace(/[^0-9]/g, "");
        $event.target.value = number;
        this.digits[index] = number;
        this.handleSubmitActivateCode();
      } else {
        this.digits[index] = null;
      }
    },

    handleSubmitActivateCode() {
      const code = this.digits.join("");
      if (code.length === this.length) {
        this.$emit("onSubmit", code);
      }
    },

    reset() {
      // $event.target.value = null;
      this.digits = Array.from(Array(this.length), () => null);
      this.$refs.inputVerify.firstElementChild.focus();
    }
  }
};
</script>
<style lang="scss" scoped>
.input-verify {
  input {
    width: 66px;
    height: 66px;
    border: none;
    outline: none;
    background-color: #f2f2f2;
    border-radius: 2px;
    margin-right: 12px;
    font-size: 20px;
    text-align: center;
  }

  input[type=number]::-webkit-inner-spin-button, 
  input[type=number]::-webkit-outer-spin-button { 
    -webkit-appearance: none; 
    margin: 0; 
  }

}

@media screen and (min-width: 320px) and (max-width: 768px) {
  .input-verify{
    input{
      width: 50px;
      height: 50px;
    }
  }
}
</style>
<style lang="scss">

</style>
